import React, { useEffect } from "react";
import { Button, Spin } from "antd";
import AddCampaign from "./AddCampaign";
import CampaignList from "./CampaignList";
import FileUpload from "./FileUpload";
import { post_camapign_data } from "../../services/FileUploadService";
import { useAuth } from "react-oidc-context";
import { DASHBOARD_API_ENDPOINT } from "../../services/oidc_constants";
import { get_outcomes_user_group } from "../../services/SessionTools";

import { Modal, Alert } from "antd";

function CampaignWizard() {
  const [campaignList, setCampaignList] = React.useState([]);
  const [showModal, setShowModal] = React.useState(false);
  const [showCampaignPostError, setShowCampaignPostError] =
    React.useState(false);
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [isUploading, setIsUploading] = React.useState(false);

  const auth = useAuth();

  const saveCampaign = (new_campaign) => {
    let campaign_list = campaignList;
    campaign_list.push(new_campaign);
    setCampaignList(campaign_list);
    console.log("campaign_list: ", campaign_list);
    setShowModal(!showModal);
  };

  const showUploadErrorFunc = (error_message) => {
    console.log("error_message: ", error_message);
    setShowCampaignPostError(true);
  };

  useEffect(() => {
    if (isUploading === true && campaignList.length > 0) {
      let converted_campaign_list = [];
      let number_of_campaigns = campaignList.length;

      for (let i = 0; i < number_of_campaigns; i++) {
        let campaign = campaignList[i];
        let converted_campaign = {
          "Flight media budget": campaign["CampaignFlightBudget"],
          "Flight Goal Type (CPC / CPCV)": campaign["GoalType"],
          "Flight goal": campaign["OutcomeNeeded"],
          "Campaign ID": campaign["CampaignId"],
          "Campaign Flight Start Date":
            campaign["CampaignFlightStartDateString"],
          "Campaign Flight End Date": campaign["CampaignFlightEndDateString"],
          "Additional E-mails for alerts (Optional)":
            campaign["AdditionalEmails"],
        };
        converted_campaign_list.push(converted_campaign);
      }

      var campaign_post_data = {
        Campaigns: converted_campaign_list,
        Username: auth.user.profile.email,
        PartnerId: "",
      };

      post_camapign_data(DASHBOARD_API_ENDPOINT, campaign_post_data, auth.user)
        .then((post_response) => {
          console.log("post_response:", post_response);
          if (post_response["success"] === true) {
            console.log("Successful post_response: ", post_response);
            setTimeout(() => {
              setCampaignList([]);
              setIsUploading(false);
              setShowSuccess(true);
            }, 5000);
          } else {
            console.log("failed posting post_response: ", post_response);
            setTimeout(() => {
              setIsUploading(false);
              setShowCampaignPostError(true);
            }, 5000);
          }
        })
        .catch((error) => {
          console.error(error);
          setIsUploading(false);
          setShowCampaignPostError(true);
        });
    } else {
    }
  }, [isUploading, campaignList, auth.user]);

  const deleteCampaign = (index) => {
    let campaign_list = campaignList;
    const campaign_index = campaign_list.findIndex(
      (campaign) => campaign["index"] === index["index"]
    );
    if (campaign_index !== -1) {
      campaign_list.splice(campaign_index, 1);
      setCampaignList(campaign_list);
    }
    setShowModal(!showModal);
  };


  let user_group = get_outcomes_user_group(auth.user);

  return (
    <div>
      <h2>Outcome Pacing Campaign Form</h2>
      {user_group !== null ? <h3>{user_group.Display}</h3> : <h3>&nbsp;</h3>}
      <span>Please use the form below to create your campaign goal list.</span>

      <Modal
        open={showCampaignPostError}
        onOk={() => setShowCampaignPostError(false)}
        onCancel={() => setShowCampaignPostError(false)}
      >
        <Alert
          message="Something went wrong submitting your changes. Please check your entries or contact admin!"
          type="error"
          banner
        />
      </Modal>

      <Modal
        open={showSuccess}
        onOk={() => setShowSuccess(false)}
        onCancel={() => setShowSuccess(false)}
      >
        <Alert
          message="Campaigns settings submitted successfully!"
          type="success"
          banner
        />
      </Modal>

      <div>
        <AddCampaign saveCampaign={saveCampaign} />
      </div>

      <div>
        {isUploading && (
          <div className="loader_overlay">
            <Spin fullscreen />
          </div>
        )}

        <CampaignList
          campaignList={campaignList}
          deleteCampaign={deleteCampaign}
        />

        <br />

        <Button
          as="button"
          data-ttd-inspect-id="back-primary-button"
          className="btn-space"
          onClick={() => setIsUploading(true)}
          disabled={campaignList.length === 0 || isUploading}
        >
          Submit Campaign List
        </Button>
      </div>

      <div style={{ paddingTop: 30 }}>
        <span>Alternatively, you can alternatively upload an Excel file:</span>
        <FileUpload showError={showUploadErrorFunc} />
        <br />
        <div>
          <p>
            Please use this template to upload your target
            campaigns:&nbsp;&nbsp;&nbsp;
            <a href="docs/outcome_pacing_template.xlsx">
              <img src="images/excel.png" alt="CSV logo" />{" "}
              <span>outcome_pacing_template.xlsx</span>
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default CampaignWizard;
